import styled, { css } from 'styled-components'
import { DynamicKeys } from '@/client/types'
import { ListStyleProps } from './types'
import { Icon } from '../Icon'
import breakpoint from '../theme/breakpoint'
import color from '../theme/color'
import font from '../theme/font'
import space from '../theme/space'

const kinds: DynamicKeys = {
  primary: `
    li svg {
      color: ${color.primary.pure};
    }

    li:hover {
      .caption {
        color: ${color.primary.pure};
      }
    }
  `,
  gold: `
    li svg {
      color: ${color.warning.pure};
    }

    li:hover {
      .caption {
        color: ${color.warning.pure};
      }
    }
  `
}

export const List = styled.ul<ListStyleProps>`
  display: flex;
  list-style: none;
  padding: 0;
  flex-direction: column;
  ${(p) => kinds[p.kind]};

  @media (min-width: ${breakpoint.lg}) {
    ${({ $double }) =>
      $double &&
      css`
        flex-direction: row;
        flex-wrap: wrap;

        & > li {
          display: flex;
          min-width: 47%;
          max-width: 47%;
          word-wrap: break-word;
          align-items: center;

          &:nth-of-type(even) {
            margin-left: 1.5%;
          }

          &:nth-of-type(odd) {
            margin-right: 1.5%;
          }
        }
      `}
  }
`

export const ListItem = styled.li<{ weight: string; inverse: boolean; size: string; border: string }>`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${space.sm};
  color: ${({ inverse }) => (inverse ? color.text.inverse : color.text.normal)};
  list-style: none;
  font-weight: ${({ weight }) => font.weight[weight]};
  font-size: ${({ size }) => (size !== 'inherit' ? font.size[size] : 'inherit')};
  border-bottom: ${({ border }) => border === 'bottom' && '0.1rem ridge #eaedf0'};
`

export const ListItemIcon = styled(Icon)`
  margin-right: ${space.xs};
  align-self: center;
`

export const Dots = styled.div`
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${color.grayscale.black};
  margin-right: ${space.xs};
  align-self: center;
`
